import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';

export const obterPedidosAvulsoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PedidoAvulso/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarPedidoAvulsoAsync = async (idFornecedor, orcamento, idCondicaoPagamento, idUnidadeAdm, observacao, desconto, acrescimo, subtotal, total, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ idFornecedor, orcamento, idCondicaoPagamento, idUnidadeAdm, observacao, desconto, acrescimo, subtotal, total, produtos })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PedidoAvulso`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}

export const editarPedidoAvulsoAsync = async (id, idFornecedor, orcamento, idCondicaoPagamento, idUnidadeAdm, observacao, desconto, acrescimo, subtotal, total, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, idFornecedor, orcamento, idCondicaoPagamento, idUnidadeAdm, observacao, desconto, acrescimo, subtotal, total, produtos })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PedidoAvulso/atualizar`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}
export const inativarPedidoAvulsoAsync = async (id, justificativa) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, justificativa })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/PedidoAvulso/inativar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .catch(handleBadRequest400);
}
export function getPdf(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/PedidoAvulso/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}
